export const getData = (key) => {

  const storedData = sessionStorage.getItem(
      key
  );

  return storedData
      ? JSON.parse(storedData)
      : null;

};



export const setData = (key,data) => {

  sessionStorage.setItem(

      key,

      JSON.stringify(data)

  );

};



export const deleteData = (key) => {

  const storedData =

  sessionStorage.getItem(
      key
  );

  if(storedData){
      sessionStorage.removeItem(
          key
      );
  }

};

const REMEMBERED_AUTH_KEY = "carrerup_remembered_auth";

export const rememberAuthSession = ({ id_user, token, user }) => {
  localStorage.setItem(
    REMEMBERED_AUTH_KEY,
    JSON.stringify({ id_user, token, user })
  );
};

export const clearRememberedSession = () => {
  localStorage.removeItem(REMEMBERED_AUTH_KEY);
};

export const hydrateRememberedSession = () => {
  if (
    sessionStorage.getItem("token") &&
    sessionStorage.getItem("user")
  ) {
    return true;
  }

  try {
    const remembered = JSON.parse(
      localStorage.getItem(REMEMBERED_AUTH_KEY)
    );

    if (!remembered?.token || !remembered?.user || !remembered?.id_user) {
      return false;
    }

    setData("id_user", remembered.id_user);
    setData("token", remembered.token);
    setData("user", remembered.user);
    return true;
  } catch (error) {
    clearRememberedSession();
    return false;
  }
};






// export const getData = (key) => {
//     const storedData = localStorage.getItem(key);
//     return storedData ? JSON.parse(storedData) : {};
//   };
  
  
// export  const setData = (key, data) => {
//     localStorage.setItem(key, JSON.stringify(data));
//   };
  


// export const deleteData = (key) => {
//     const storedData = localStorage.getItem(key);
//     if(storedData){
//       localStorage.removeItem(key);
//     }

//   };
  
